import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRevealOnScroll } from '../hooks/useRevealOnScroll';
import HomepageHeader from '../components/HomepageHeader';
import HomepageNav from '../components/HomepageNav';
import MobileNav from '../components/MobileNav';
import MobileHeroImage from '../components/MobileHeroImage';
import HomeInfo from '../components/HomeInfo';
import HomeAbout from '../components/HomeAbout';
import TeamSection from '../components/TeamSection';
import HomeMoreInfos from '../components/HomeMoreInfos';
import ServicesGrid from '../components/ServicesGrid';
import NewsPreview from '../components/NewsPreview';
import RechnerGallery from '../components/RechnerGallery';
import ContactCTA from '../components/ContactCTA';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import './Homepage.css';

const Homepage = () => {
  useRevealOnScroll();
  const location = useLocation();

  // Scroll zu Sektion wenn von anderer Seite kommend
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.querySelector(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Kleine Verzögerung für sicheres Scrollen
      }
    }
  }, [location]);
  return (
    <div className="homepage">
      <HomepageNav />
      <MobileNav />
      <HomepageHeader />
      <MobileHeroImage />
      <HomeInfo />
      <HomeAbout />
      <TeamSection />
      <HomeMoreInfos />
      <ServicesGrid />
      <ContactCTA />
      <Testimonials />
      <NewsPreview />
      <RechnerGallery />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Homepage;
